<div class="device-switcher-container" (click)="writeValue(!value)">
  <div class="device-switcher-box">
    <div class="switcher-name left" [ngClass]="value ? 'active' : ''" fxFlex>{{ names.left }}</div>
    <div class="switcher-name right" [ngClass]="!value ? 'active' : ''" fxFlex>{{ names.right }}</div>

    <div class="switch-point" [ngClass]="value ? 'left' : 'right'"></div>
  </div>
</div>
